<template>
  <NotificationTypeWrapper :notification="notification">
    <p class="my-0">
      A new
      <a
        :href="actionLink"
        v-text="`blog entry`"
      />
      <strong v-text="title" /> has been published.
    </p>
  </NotificationTypeWrapper>
</template>

<script type="text/babel">
import NotificationTypeMixin from './NotificationTypeMixin'

export default {
  name: 'BlogEntryHasBeenPublished',
  mixins: [NotificationTypeMixin],
  computed: {
    title() {
      return this.notification.attributes.data.blog_entry_title
        ? `(${this.notification.attributes.data.blog_entry_title})`
        : ''
    },
    actionLink() {
      return this.$urlGenerator.active() + 'communications/blog/' + this.notification.attributes.data.blog_entry_uuid
    },
  },
}
</script>
